<template>
  <list :listTitle="$t('tokens.label')" :loading="loading" :total="toolApiTotalTokens" :typesListAvailable="['displayList']" :sortFields="sortFields" :sortDefault="{ field: sortFields[0], order: 'desc' }" @change="onChange">
    <span class="btn btn--info" slot="header-actions" @click="createToken()">Criar</span>
    <template slot="filters">
      <form-group label="Status">
        <select v-model="options.status" class="form-select">
          <option :value=null>Todos</option>
          <option :value=true>Ativo</option>
          <option :value=false>Inativo</option>
        </select>
      </form-group>
    </template>

    <div class="l-col-12@md" v-for="token in toolApiTokens" :key="token">
      <token-card :token="token"/>
    </div>
    <div class="l-col u-textCenter" v-if="!toolApiTokens.length">
      <panel>
        Nenhum token encontrado.
      </panel>
    </div>
  </list>
</template>

<script>
  import { mapActions } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { merge } from 'lodash'
  import List from '@/components/shared/list/Paginator'
  import FormGroup from '@/components/template/FormGroup'
  import TokenCard from '@/components/tool/api/TokenCard'
  import Panel from '@/components/template/Panel'

  export default {
    data: () => ({
      options: {
        status: null
      },
      loading: false,
      sortFields: [
        'date.created'
      ]
    }),
    methods: {
      ...mapActions('toolApi', [
        'fetchTokens'
      ]),
      async onChange (options) {
        this.loading = true

        merge(this.options, options)

        await this.fetchTokens({ options: this.options })

        this.loading = false
      },
      createToken () {
        this.$router.push('/tool/api/tokens/create')
      }
    },
    computed: {
      ...mapFields({
        toolApiTotalTokens: 'toolApi.totalTokens',
        toolApiTokens: 'toolApi.tokens'
      })
    },
    components: {
      List,
      FormGroup,
      TokenCard,
      Panel
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// List.vue?077269c3